var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{staticClass:"animate__animated animate__fadeIn content-modal",attrs:{"close-on-click-modal":false,"title":_vm.title,"visible":_vm.visible,"width":_vm.width,"center":""},on:{"update:visible":function($event){_vm.visible=$event},"close":_vm.onClose}},[_c('div',{attrs:{"id":"dialog-box"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }